<div class="snackbar-content d-flex align-items-center py-2">

  <div class="d-flex align-items-center fw-bold me-2">
    <ng-container *ngIf="type === 'success'">
      <svg class="icon-26 me-2"><use href="#icon-check-circle" /></svg>
      {{ 'SCREEN_PRECHECKIN_SNACKBAR.SUCCESS' | translate }}
    </ng-container>
    <ng-container *ngIf="type === 'warning'">
      <svg class="icon-26 me-2"><use href="#icon-warning" /></svg>
      {{ 'SCREEN_PRECHECKIN_SNACKBAR.WARNING' | translate }}
    </ng-container>
    <ng-container *ngIf="type === 'error'">
      <svg class="icon-26 me-2"><use href="#icon-close-circle" /></svg>
      {{ 'SCREEN_PRECHECKIN_SNACKBAR.ERROR' | translate }}
    </ng-container>
    <ng-container *ngIf="type === 'info'">
      <svg class="icon-26 me-2"><use href="#icon-info" /></svg>
      {{ 'SCREEN_PRECHECKIN_SNACKBAR.INFO' | translate }}
    </ng-container>
  </div>
  
  {{message | translate}}

  <div class="close-snackbar text-primary" (click)="close()">
    <svg class="icon"><use href="#icon-close" /></svg>
  </div>
</div>